<div class="hp-pw-wrapper">

  <!-- Native password input -->
  <input
    [attr.id]="name"
    [name]="name"
    [type]="inputType"
    [placeholder]="placeholder"
    [value]="value"
    autocomplete="current-password"
    autocapitalize="off"
    spellcheck="false"
    class="hp-pw-entry"
    (input)="onInput($event)"
    (blur)="onBlur()"
  />

  <!-- Eye toggle button -->
  <button
    type="button"
    class="hp-pw-eye"
    [class.hp-pw-eye--has-value]="value?.length"
    (click)="onToggleReveal()"
    [attr.aria-label]="isShow ? 'パスワードを隠す' : 'パスワードを表示する'"
    tabindex="-1"
  >
    <!-- Eye open (password hidden) -->
    <svg *ngIf="!isShow" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
    </svg>
    <!-- Eye closed (password visible) -->
    <svg *ngIf="isShow" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.28,4.5 8.67,4.9 7.24,5.65L9.27,7.68C10.12,7.25 11.03,7 12,7Z"/>
    </svg>
  </button>

</div>
